var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48483 1.23483C3.63128 1.08839 3.86872 1.08839 4.01517 1.23483L8.51516 5.73484C8.66161 5.88128 8.66161 6.11872 8.51516 6.26516L4.01517 10.7652C3.86872 10.9116 3.63128 10.9116 3.48483 10.7652C3.33839 10.6187 3.33839 10.3813 3.48483 10.2348L7.71967 6L3.48483 1.76517C3.33839 1.61872 3.33839 1.38128 3.48483 1.23483Z",
    fill: "#168794",
    stroke: "#168794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.db50bf7a5b672a69cfe568bcd14af9fc.svg";
export { ForwardRef as ReactComponent };